<template>
  <v-container fluid>

    <v-card>
      <v-card-title>
        <v-btn color="primary" class="mr-2" dark @click.native="cancelar()" icon="icon">
          <v-icon>arrow_back</v-icon>
        </v-btn>

        <span class="headline">{{titulo}}</span>

        <v-spacer></v-spacer>

        <v-btn to="/admin/unidade" router  icon="icon">
          <v-icon>list</v-icon>
        </v-btn>
      </v-card-title>

      <form validate v-on:submit.prevent="onSubmit">

      <v-card-text>
        <UnidadeForm :unidade="unidade"> </UnidadeForm>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <div class=""> <v-btn color="secondary" dark ripple @click.native="cancelar()">Cancelar</v-btn></div>
        <div class="pl-3"> <v-btn color="primary" type="submit" dark ripple>Gravar</v-btn></div>
      </v-card-actions>

      </form>

      <v-snackbar
        :timeout="timeoutAlerta"
        :color="tipoAlerta"
        v-model="snackbar">
        {{ textAlerta }}
        <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
      </v-snackbar>


    </v-card>
  </v-container>
</template>

<script>

import UnidadeForm from '@/components/UnidadeForm'
import axios from 'axios'

export default {
  name: 'unidade-new',
  data () {
    return {
      unidade: {},
      titulo: 'Criar Unidade',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    }
  },
  components: {
    UnidadeForm
  },
  methods: {
    loadModel () {
      this.unidade = {
        nome: '',
        cnpj: '',
        intervaloStorage: '',
        cor: '',
        idSistema: '',
        assinatura: false,
        qrcode: false,
        ativa: false
      }
    },
    onSubmit () {
      var self = this
      axios.post(`/unidades`, this.unidade)
      .then(function (response) {
        self.$store.commit('changeUnidadeQuery', {query: self.unidade.nome})
        self.$router.push({name: 'Unidade'})
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao criar unidade ' + e
        self.snackbar = true
      })
    },
    cancelar () {
      this.$router.go(-1)
    }
  },
  created () {
    this.loadModel()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UnidadeNew.vue?40030539